/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} A11y_Statement_Enforcement_StreetInputs */

const en_a11y_statement_enforcement_street = /** @type {(inputs: A11y_Statement_Enforcement_StreetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Turmschanzenstrasse 25`)
};

const de_a11y_statement_enforcement_street = /** @type {(inputs: A11y_Statement_Enforcement_StreetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Turmschanzenstraße 25`)
};

const fr_a11y_statement_enforcement_street = /** @type {(inputs: A11y_Statement_Enforcement_StreetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Turmschanzenstrasse 25`)
};

const es_a11y_statement_enforcement_street = /** @type {(inputs: A11y_Statement_Enforcement_StreetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Turmschanzenstrasse 25`)
};

const it_a11y_statement_enforcement_street = /** @type {(inputs: A11y_Statement_Enforcement_StreetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Turmschanzenstrasse 25`)
};

const nl_a11y_statement_enforcement_street = /** @type {(inputs: A11y_Statement_Enforcement_StreetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Turmschanzenstrasse 25`)
};

const pl_a11y_statement_enforcement_street = /** @type {(inputs: A11y_Statement_Enforcement_StreetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Turmschanzenstrasse 25`)
};

const fi_a11y_statement_enforcement_street = /** @type {(inputs: A11y_Statement_Enforcement_StreetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Turmschanzenstrasse 25`)
};

const da_a11y_statement_enforcement_street = /** @type {(inputs: A11y_Statement_Enforcement_StreetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Turmschanzenstrasse 25`)
};

const sv_a11y_statement_enforcement_street = /** @type {(inputs: A11y_Statement_Enforcement_StreetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Turmschanzenstrasse 25`)
};

/**
* | output |
* | --- |
* | "Turmschanzenstrasse 25" |
*
* @param {A11y_Statement_Enforcement_StreetInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const a11y_statement_enforcement_street = /** @type {((inputs?: A11y_Statement_Enforcement_StreetInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<A11y_Statement_Enforcement_StreetInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_a11y_statement_enforcement_street(inputs)
	if (locale === "fr") return fr_a11y_statement_enforcement_street(inputs)
	if (locale === "es") return es_a11y_statement_enforcement_street(inputs)
	if (locale === "it") return it_a11y_statement_enforcement_street(inputs)
	if (locale === "nl") return nl_a11y_statement_enforcement_street(inputs)
	if (locale === "pl") return pl_a11y_statement_enforcement_street(inputs)
	if (locale === "fi") return fi_a11y_statement_enforcement_street(inputs)
	if (locale === "da") return da_a11y_statement_enforcement_street(inputs)
	if (locale === "sv") return sv_a11y_statement_enforcement_street(inputs)
	return en_a11y_statement_enforcement_street(inputs)
});